
export default function (input) {
  const reg = '\\d(?=(\\d{3})+$)';
  return input ? `$${`${input}`.replace(/[^0-9]/g, '').replace(new RegExp(reg, 'g'), '$&,')}` : '';
}



// WEBPACK FOOTER //
// ./shared/lib/prettyMoney.js